export default __webpack_public_path__ + "static/media/dropbox.b3021b2d.svg";